module.exports = __webpack_public_path__ + "img/linkedin-in.b3c6304b.svg";